"use strict";
import UploadApi from './UploadApi';
import { commandApi } from './commandApi';
var configPromise = require('../config').configPromise;
var Api = require('./api');
var ORGANISATIONS_URL = '/api/organisations';
var URL_ID_QUERY = '/{0}';
var ORGANISATIONS_USER_LIST_URL = ORGANISATIONS_URL + URL_ID_QUERY + "/users",
  ORGANISATIONS_ROLES_URL = ORGANISATIONS_URL + URL_ID_QUERY + "/roles",
  ORGANISATION_LOOKUP_URL = ORGANISATIONS_URL + "/GetLookup";
const GET_ORGANISATIONS_SETTINGS_COMMAND = 'get-organisations-settings';
const SAVE_ORGANISATIONS_SETTINGS_2BAP_COMMAND = '2bap:save-organisation-settings';

/**
 * Organisations api
 * @type {{getOrganisationList: OrganisationsApi.getOrganisationList, getOrganisation: OrganisationsApi.getOrganisation, createOrganisation: OrganisationsApi.createOrganisation, updateOrganisation: OrganisationsApi.updateOrganisation}}
 */
var OrganisationsApi = {

  /*<editor-fold desc="[ Organisation Api ]">*/

  /**
   * Get organisation list
   * GET api/Organisations
   * @param pageObject page object for a list
   * @returns {*} organisation list
   */
  getOrganisationList: function (pageObject) {
    return configPromise
      .then(function (config) {
        return Api.get(config.apiPath(ORGANISATIONS_URL), pageObject);
      });
  },

  /**
   * Get organisation lookup list
   * GET api/organisations/GetLookup
   * @returns {*} organisation lookup list
   */
  getOrganisationLookupList: function () {
    return configPromise
      .then(function (config) {
        return Api.get(config.apiPath(ORGANISATION_LOOKUP_URL));
      });
  },

  /**
   * Get organisation
   * GET api/Organisations/{id}
   * @param organisationId organisation identifier
   * @returns {*} organisation
   */
  getOrganisation: function (organisationId) {
    return configPromise
      .then(function (config) {
        return Api.get(config.apiPath(ORGANISATIONS_URL + URL_ID_QUERY, [organisationId]));
      });
  },

  /**
   * Get organisation user list
   * GET api/organisations/{id}/users
   * @param pageObject page object for a list
   * @param organisationId source organisation id
   * @returns {*} user list by organisation
   */
  getOrganisationUserList: function (pageObject, organisationId) {
    return configPromise
      .then(function (config) {
        return Api.get(config.apiPath(ORGANISATIONS_USER_LIST_URL, [organisationId]), pageObject);
      });
  },

  /**
   * Get organisation roles
   * GET api/organisations/{id}/roles
   * @param organisationId source organisation id
   * @returns {*} role list by organisation
   */
  getOrganisationRoleList: function (organisationId) {
    return configPromise
      .then(function (config) {
        return Api.get(config.apiPath(ORGANISATIONS_ROLES_URL, [organisationId]));
      });
  },

  async deleteOrganisationUser(organisationId, userId) {
    return this.processOrganisationUser(organisationId, userId, Api.delete);
  },

  async getOrganisationUserDetails(organisationId, userId) {
    return this.processOrganisationUser(organisationId, userId, Api.get);
  },

  async processOrganisationUser(organisationId, userId, apiHandler) {
    const config = await configPromise;
    const url = `${ORGANISATIONS_URL}/${organisationId}/users/${userId}`;
    return apiHandler(config.apiPath(url));
  },

  /**
   * Create organisation
   * POST api/Organisations
   * @param data organisation data
   * @returns {*} identifier of created organisation
   */
  createOrganisation: function (data) {
    return configPromise
      .then(function (config) {
        return Api.post(config.apiPath(ORGANISATIONS_URL), data);
      });
  },

  /**
   * Update organisation
   * PUT api/Organisations/{id}
   * @param organisationId organisation identifier
   * @param data organisation data
   * @returns {*} identifier of updated organisation
   */
  updateOrganisation: function (organisationId, data) {
    return configPromise
      .then(function (config) {
        return Api.put(config.apiPath(ORGANISATIONS_URL + URL_ID_QUERY, [organisationId]), data);
      });
  },

  getSaleSources: function () {
    return configPromise
      .then(function (config) {
        return Api.get(config.apiPath('/api/organisations/salesSources'));
      });
  },

  uploadOrganisationFile(file, progressHandler) {
    const url = '/api/organisation-files';

    return configPromise
      .then(function (config) {
        return UploadApi.uploadFile(file, progressHandler, undefined, url)
          .then(function (response) {
            const body = response.body;
            body.url = config.cdnPath(body.content);
            return body;
          })
      });
  },

  /**
   * @return {Promise<OrganisationSettingsModel>}
   */
  getOrganisationSettings() {
    return commandApi.send(GET_ORGANISATIONS_SETTINGS_COMMAND);
  },

  /**
   * @param {number} schoolId
   * @param {Object} settingKeyValues
   */
  saveOrganisationSettings2bap(schoolId, settingKeyValues) {
    return commandApi.send(SAVE_ORGANISATIONS_SETTINGS_2BAP_COMMAND, { schoolId, settingKeyValues });
  }

  /*</editor-fold desc="[ Organisation Api ]">*/
};

module.exports = OrganisationsApi;
